const TIME_ONLY_OPTIONS: Intl.DateTimeFormatOptions = {
  hour: "numeric",
  minute: "2-digit",
};

const DATE_AND_TIME_OPTIONS: Intl.DateTimeFormatOptions = {
  month: "short",
  day: "numeric",
  ...TIME_ONLY_OPTIONS,
};

/**
 * How a due date reads everywhere a task is listed: "Mar 14, 9:00 AM", or just
 * "9:00 AM" under a heading that already names the day.
 *
 * Never seconds. The default `toLocaleString` produced "3/14/2026, 9:00:00 AM":
 * twenty-two characters of a row, three of them pure noise, and the ":00" was
 * the last thing on the line, so it was what the eye landed on. Nobody
 * schedules a call for 9:00:00.
 *
 * One formatter, so the same task cannot read two different ways on two
 * screens.
 */
export const formatTaskDueDate = (
  dueDate: string,
  locale?: string,
  timeOnly = false,
) =>
  new Date(dueDate).toLocaleString(
    locale,
    timeOnly ? TIME_ONLY_OPTIONS : DATE_AND_TIME_OPTIONS,
  );
